import React from 'react'
import { Link, useLocation } from 'react-router-dom'

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

function NavLinkM({ name, href }) {
    const location = useLocation();
    let currentLocation = false;

    if (href === location.pathname)
        currentLocation = true;

    return (
        <Link
            key={name}
            as="a"
            to={href}
            className={classNames(
                currentLocation ? 'bg-blue-3005C text-white' : 'text-white hover:bg-blue-2915C hover:text-white',
                'block px-3 py-2 rounded-md text-base font-medium'
            )}
            aria-current={currentLocation ? 'page' : undefined}
        >
            {name}
        </Link>
    )
}

export default NavLinkM